/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import React, { useCallback } from 'react'
import { Switch, SwitchProps } from '@mantine/core'
import { useIntl } from 'react-intl'

export type LockedInputProps = Omit<SwitchProps, 'onChange' | 'type' | 'value'> & {
  onChange (value: boolean): void,
  value?: boolean
}

function LockedInput (props: LockedInputProps) {
  const { onChange, value, ...others } = props
  const intl = useIntl()

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked)
  }, [onChange])

  return (
    <Switch
      name="locked"
      color="green"
      label={intl.formatMessage({
        id: 'locked',
        defaultMessage: 'Verrouillé'
      })}
      {...others}
      checked={String(value) === 'true'}
      onChange={handleChange}
      value={value != null ? String(value) : null}
    />
  )
}

export default LockedInput
